import $ from 'jquery';

function disclaimerSticky() {
	var $toggle 	= $('.c-disclaimer-sticky_toggle'),
			$content 	= $('.c-disclaimer-sticky_content');
	
	$toggle.click(function() {
		$content.slideToggle();
	});
}

export { disclaimerSticky };